import ActionTypes from './actionTypes';

/**
 * Get list of scheduled reports
 * */
export function getScheduledReportsList(grandParentAccountNumber, contractIdentifier, limit, offset, sortColumn,
  sortDirection, searchTerm) {
  return {
    type: ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      limit,
      offset,
      sortColumn,
      sortDirection,
      searchTerm
    }
  };
}

export function getScheduledReportsListSuccess(response) {
  return {
    type: ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.SUCCESS,
    payload: {
      scheduledReportsList: response.result,
      scheduledReportsListResultSize: response.resultSize
    }
  };
}

export function getScheduledReportsListFailure() {
  return {
    type: ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.FAILURE
  };
}

export function getScheduledReportsListReset() {
  return {
    type: ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.RESET
  };
}

/**
 * Get scheduled report details
 * */
export function getScheduledReport(grandParentAccountNumber, contractIdentifier, reportScheduleId) {
  return {
    type: ActionTypes.REPORTS.GET_SCHEDULED_REPORT.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      reportScheduleId
    }
  };
}

export function getScheduledReportSuccess(response) {
  return {
    type: ActionTypes.REPORTS.GET_SCHEDULED_REPORT.SUCCESS,
    payload: {
      scheduledReport: response,
    }
  };
}

export function getScheduledReportFailure() {
  return {
    type: ActionTypes.REPORTS.GET_SCHEDULED_REPORT.FAILURE
  };
}

/**
 * Create scheduled report
 * */
export function createScheduledReport(grandParentAccountNumber, contractIdentifier, request) {
  return {
    type: ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      request
    }
  };
}

export function createScheduledReportSuccess() {
  return {
    type: ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.SUCCESS
  };
}

export function createScheduledReportFailure() {
  return {
    type: ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.FAILURE
  };
}

export function createScheduledReportReset() {
  return {
    type: ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.RESET
  };
}

/**
 * Update scheduled report
 * */
export function updateScheduledReport(grandParentAccountNumber, contractIdentifier, reportScheduleId, request) {
  return {
    type: ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      reportScheduleId,
      request
    }
  };
}

export function updateScheduledReportSuccess() {
  return {
    type: ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.SUCCESS
  };
}

export function updateScheduledReportFailure() {
  return {
    type: ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.FAILURE
  };
}

export function updateScheduledReportReset() {
  return {
    type: ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.RESET
  };
}

/**
 * Delete scheduled report
 * */
export function deleteScheduledReport(grandParentAccountNumber, contractIdentifier, reportScheduleId) {
  return {
    type: ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      reportScheduleId
    }
  };
}

export function deleteScheduledReportSuccess() {
  return {
    type: ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.SUCCESS
  };
}

export function deleteScheduledReportFailure() {
  return {
    type: ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.FAILURE
  };
}

export function deleteScheduledReportReset() {
  return {
    type: ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.RESET
  };
}

/**
 * Enable scheduled report
 * */
export function enableScheduledReport(grandParentAccountNumber, contractIdentifier, reportScheduleId) {
  return {
    type: ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      reportScheduleId
    }
  };
}

export function enableScheduledReportSuccess() {
  return {
    type: ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.SUCCESS
  };
}

export function enableScheduledReportFailure() {
  return {
    type: ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.FAILURE
  };
}

export function enableScheduledReportReset() {
  return {
    type: ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.RESET
  };
}

/**
 * Disable scheduled report
 * */
export function disableScheduledReport(grandParentAccountNumber, contractIdentifier, reportScheduleId) {
  return {
    type: ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      reportScheduleId
    }
  };
}

export function disableScheduledReportSuccess() {
  return {
    type: ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.SUCCESS
  };
}

export function disableScheduledReportFailure() {
  return {
    type: ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.FAILURE
  };
}

export function disableScheduledReportReset() {
  return {
    type: ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.RESET
  };
}

/**
 * Get list of reports
 * */
export function getReportsList(grandParentAccountNumber, contractIdentifier, limit, offset, sortColumn, sortDirection, searchTerm) {
  return {
    type: ActionTypes.REPORTS.GET_REPORTS_LIST.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      limit,
      offset,
      sortColumn,
      sortDirection,
      searchTerm
    }
  };
}

export function getReportsListSuccess(response) {
  return {
    type: ActionTypes.REPORTS.GET_REPORTS_LIST.SUCCESS,
    payload: {
      reportsList: response.result,
      reportsListResultSize: response.resultSize
    }
  };
}

export function getReportsListFailure() {
  return {
    type: ActionTypes.REPORTS.GET_REPORTS_LIST.FAILURE
  };
}

export function getReportsListReset() {
  return {
    type: ActionTypes.REPORTS.GET_REPORTS_LIST.RESET
  };
}
/**
 * Download a report
 * */
export function downloadReport(grandParentAccountNumber, contractIdentifier, documentId, reportName, contentType) {
  return {
    type: ActionTypes.REPORTS.DOWNLOAD_REPORT.REQUEST,
    payload: {
      grandParentAccountNumber,
      contractIdentifier,
      documentId,
      reportName,
      contentType
    }
  };
}

export function downloadReportSuccess() {
  return {
    type: ActionTypes.REPORTS.DOWNLOAD_REPORT.SUCCESS
  };
}

export function downloadReportFailure() {
  return {
    type: ActionTypes.REPORTS.DOWNLOAD_REPORT.FAILURE
  };
}
